import { render, staticRenderFns } from "./HelpButton.vue?vue&type=template&id=352ae9b0&scoped=true&"
import script from "./HelpButton.vue?vue&type=script&lang=js&"
export * from "./HelpButton.vue?vue&type=script&lang=js&"
import style0 from "./HelpButton.vue?vue&type=style&index=0&id=352ae9b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ae9b0",
  null
  
)

export default component.exports